import axios from 'axios';
import { inject } from 'vue';
import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';

export default () => {
  const arcaneApiGateway = inject('arcaneApiGateway');

  const getUserFiles = async () => {
    try {
      const response = await arcaneApiGateway.get(apiGatewayEndpoints.files.userFiles);
      return response.data?.results || [];
    } catch (e) {
      console.log('Error in getting user files', e);
      return [];
    }
  };

  const uploadUserFile = async (file) => {
    try {
      const documents = [file.name];
      const response = await arcaneApiGateway.post(apiGatewayEndpoints.files.uploadFile, { documents });
      const uploadUrl = (response.data?.results?.length && response.data?.results[0].uploadUrl) || '';
      const puts3Response = await axios.put(uploadUrl, file);
      return puts3Response?.config?.data || null;
    } catch (e) {
      console.log('Error in getting user files', e);
      return null;
    }
  };

  const removeFile = async (fileId) => {
    try {
      const documents = [fileId];
      const response = await arcaneApiGateway.delete(apiGatewayEndpoints.files.userFiles, {
        data: {
          documents,
        },
      });
      return response;
    } catch (e) {
      console.log('Error in removing user file', e);
      return null;
    }
  };

  return {
    getUserFiles,
    removeFile,
    uploadUserFile,
  };
};
